module.exports = __webpack_public_path__ + "img/logos.d56bbcdf.png";